import { FontSizeConfig } from '../types/types';

export const getS2cBannerFontFromCountry = (country?: string): FontSizeConfig => {
    const phoneFontSizesMap = {
        de: { mobileFontSize: 20, desktopFontSize: 24 },
        ch: { mobileFontSize: 15, desktopFontSize: 18 },
        cz: { mobileFontSize: 15, desktopFontSize: 18 },
        sk: { mobileFontSize: 20, desktopFontSize: 24 },
        pl: { mobileFontSize: 20, desktopFontSize: 24 },
        nl: { mobileFontSize: 20, desktopFontSize: 24 },
        it: { mobileFontSize: 20, desktopFontSize: 24 },
        fr: { mobileFontSize: 20, desktopFontSize: 24 },
        es: { mobileFontSize: 20, desktopFontSize: 24 },
    };

    const defaultFontSizes = { mobileFontSize: 20, desktopFontSize: 24 };
    return country ? phoneFontSizesMap[country] || defaultFontSizes : defaultFontSizes;
};
